<template>
  <div>
    <div class="news-top"></div>
    <div class="page_padding marginB">
      <div class="text-left title marginT">
        <span>{{ title }}</span>
      </div>
      <div class="text-left date">
        <span>{{ date }}</span>
      </div>
      <div v-if="!isReady">
        <loading-spinner></loading-spinner>
      </div>
      <div v-else class="content" v-html="html"></div>
      <div class="news-bottom">
        <router-link to="/news" class="link">
          <div class="btn-write">목록으로</div>
        </router-link>
        <div v-if="checkLogin()" class="delete" @click="openMoal">
          삭제하기
        </div>
        <delete-modal
          v-if="isOpenModal"
          @click-left="isOpenModal = false"
          @click-right="deleteArticle"
        ></delete-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {getArticleDetail, getArticleDelete} from "@/api/index";
import {checkLogin} from "@/utils/admin";
import loadingSpinner from "@/components/loadingSpinner.vue";
import DeleteModal from "./delete-modal.vue";
export default {
  components: {loadingSpinner, DeleteModal},
  data() {
    return {
      article: {},
      title: "",
      date: "",
      html: "",
      isReady: false,

      isOpenModal: false,
    };
  },
  methods: {
    async getArticleDetail(id) {
      getArticleDetail(id);
    },
    async deleteArticle() {
      getArticleDelete(this.article.Key).then((result) => {
        if (result.status === 200) {
          this.$router.push("/news");
        } else {
          alert("게시물을 삭제하지 못했습니다.");
        }
      });
    },

    openMoal() {
      this.isOpenModal = true;
    },
    checkLogin,
  },
  mounted() {
    if (this.$route.params.item !== undefined) {
      this.title = this.$route.params.item.Title;
      this.date = this.$route.params.item.Date;
    }
    let getData = async () => {
      await getArticleDetail(this.$route.query.id)
        .then((result) => {
          if (result.status === 200) {
            this.article = result.data;
            this.title = result.data.Title;
            this.date = result.data.Date;
            this.html = result.data.Content;
            this.isReady = true;
          }
        })
        .catch(() => {
          alert("본문을 불러오지 못했습니다.");
        });
    };
    getData();
  },
};
</script>
<style>
@import "~vue2-editor/dist/vue2-editor.css";
</style>
<style scoped>
.title span {
  font-size: 22px;
}
.date {
  margin: 20px 0 40px;
}
.date span {
  font-size: 14px;
  color: #9e9e9e;
}
.content {
  border-top: 2px solid black;
  border-bottom: 1px solid black;
  padding: 80px 0;
}
.content >>> img {
  max-width: 100%;
}
.btn-write {
  width: 104px;
  border: 1px solid lightgrey;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  margin: 20px auto;
}
.link {
  margin: 0 auto;
  text-decoration: none;
}
.news-bottom {
  display: flex;
}
.news-bottom a:nth-child(1) {
  margin-right: 20px;
}
.news-bottom {
  width: 232px;
  margin: 0 auto;
}
.delete {
  width: 104px;
  border: 1px solid #3d3d3d;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  margin: 20px auto;
  color: white;
  background-color: #3d3d3d;
}
</style>
